import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { Section, useLanding } from '@/components/Landing/LandingKit';
import { fluid } from '@/components/Landing/landingTokens';
import { AboutBody, AboutSplit } from './AboutKit';

function AboutHero({ topInset = 0 }) {
  const { c, isXS, isCompact, width } = useLanding();
  const size = fluid(width, 40, 68);

  return (
    <Section label="About Gab AI" contentStyle={{ paddingTop: (isXS ? topInset : 0) + fluid(width, 108, 152), paddingBottom: fluid(width, 44, 72) }}>
      <Text weight="medium" style={{ color: c.accent, fontSize: 14, marginBottom: 26 }}>About Gab AI</Text>
      <AboutSplit style={{ alignItems: isCompact ? 'stretch' : 'flex-end' }}>
        <View style={{ flex: isCompact ? undefined : 1.2, minWidth: 0 }}>
          <Text tag="h1" weight="semibold" style={{ color: c.ink, fontSize: size, lineHeight: Math.round(size * 1.06), letterSpacing: -size * 0.045 }}>
            AI should expand what you can do.
          </Text>
        </View>
        <View style={{ flex: isCompact ? undefined : 1, minWidth: 0, paddingBottom: isCompact ? 0 : 3 }}>
          <AboutBody style={{ fontSize: 18, lineHeight: 30, maxWidth: 450 }}>
            We’re an independent American company building AI for people who want to think, create, and get things done. You bring the ideas. We build the tools to help you make them real.
          </AboutBody>
          <Text style={{ color: c.muted, fontSize: 13, lineHeight: 21, marginTop: 24 }}>Founded 2016 · Pennsylvania, USA</Text>
        </View>
      </AboutSplit>
    </Section>
  );
}

export default React.memo(AboutHero);
